const join = (o, t) => {
  return o.replace(/\/+$/, "") + "/" + t.replace(/^\/+/, "");
};

export const BASE_IMG = path => join("https://cdn.cardcash.com/website", path);

export const UI_IMG = path => join(BASE_IMG("/ui"), path);

export const NAV_IMG = path => join(UI_IMG("/nav"), path);
